function getTaskEntryState(stats) {
  switch (true) {
    case stats?.correct === stats?.total:
      return "correct";
    case stats?.correct !== 0:
      return "partial";
    default:
      return "incorrect";
  }
}

export { getTaskEntryState };
//# sourceMappingURL=get-task-entry-state.js.map
